/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'video_invert': {
    width: 17,
    height: 14,
    viewBox: '0 0 17 14',
    data: '<path pid="0" d="M14 0a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h11zM6.887 4A.887.887 0 0 0 6 4.887v4.226a.887.887 0 0 0 1.284.793l4.225-2.113a.887.887 0 0 0 0-1.586L7.284 4.094A.887.887 0 0 0 6.887 4z" _fill="#797979" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/video_invert.js